export default {
	DEFAULT_ZOOM: 6,
	PREVIEW_MAP_ZOOM: 2,
	INITIAL_CENTER: [-78.0428, -12.0464],
	ACCESS_TOKEN: 'pk.eyJ1IjoiYmFydDAwIiwiYSI6ImNqd3J2ZnJqZzFvajE0N21ndDhneDNhbnQifQ.TfJ_ac_NU1EjbWM0KpQewg',
	MAPBOX_STYLE: 'mapbox://styles/bart00/cjzfe37w30i8c1cnu0gfmbr1h',
	POINT_OF_INTEREST_DISTANCE: 1000
}